import { Data_getInstance17eky330o03un as Data_getInstance } from './adapter/DeletePairAssignmentsMutation_ResponseAdapter.mjs';
import { getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { obj2vqjd1bjrpmyg as obj } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { Companion_getInstanceoymipm3rjnhd as Companion_getInstance } from './type/Mutation.mjs';
import { Builder320ghmibyd2no as Builder } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/CompiledGraphQL.mjs';
import { DeletePairAssignmentsMutationSelections_getInstance27p0rhnwotgkw as DeletePairAssignmentsMutationSelections_getInstance } from './selections/DeletePairAssignmentsMutationSelections.mjs';
import { DeletePairAssignmentsMutation_VariablesAdapter_instance22zrcennykos6 as DeletePairAssignmentsMutation_VariablesAdapter_instance } from './adapter/DeletePairAssignmentsMutation_VariablesAdapter.mjs';
import { Mutationkenyz0l5btz as Mutation } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Mutation.mjs';
import { ApolloAdaptableWith1g871415y7ifs as ApolloAdaptableWith } from '../../../../../../apollo-kotlin-apollo-annotations/com/apollographql/apollo/annotations/ApolloAdaptableWith.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DataClass;
function Data() {
  if (DataClass === VOID) {
    class $ {
      constructor(deletePairAssignments) {
        this.c6i_1 = deletePairAssignments;
      }
      toString() {
        return 'Data(deletePairAssignments=' + this.c6i_1 + ')';
      }
      hashCode() {
        return this.c6i_1 == null ? 0 : getBooleanHashCode(this.c6i_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Data()))
          return false;
        if (!(this.c6i_1 == other.c6i_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Data', VOID, VOID, VOID, VOID, VOID, {1: Data_getInstance});
    DataClass = $;
  }
  return DataClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.d6i_1 = obj(Data_getInstance());
        this.e6i_1 = (new (Builder())('data', Companion_getInstance().g6h_1)).p46(DeletePairAssignmentsMutationSelections_getInstance().h6i_1).e3a();
        this.f6i_1 = '5f431795769da9adf5424eb986e567d7f3d0c969eea1d72c008a4cdfcc11adf1';
        this.g6i_1 = 'deletePairAssignments';
      }
      j6h() {
        return 'mutation deletePairAssignments($input: DeletePairAssignmentsInput!) { deletePairAssignments(input: $input) }';
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance_0() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var DeletePairAssignmentsMutationClass;
function DeletePairAssignmentsMutation() {
  if (DeletePairAssignmentsMutationClass === VOID) {
    class $ {
      constructor(input) {
        Companion_getInstance_0();
        this.i6i_1 = input;
      }
      l6h() {
        return '5f431795769da9adf5424eb986e567d7f3d0c969eea1d72c008a4cdfcc11adf1';
      }
      operationId() {
        return this.l6h();
      }
      i4a() {
        return Companion_getInstance_0().j6h();
      }
      m6h() {
        return 'deletePairAssignments';
      }
      operationName() {
        return this.m6h();
      }
      m49(writer, customScalarAdapters, withDefaultValues) {
        DeletePairAssignmentsMutation_VariablesAdapter_instance.j6i(writer, this, customScalarAdapters, withDefaultValues);
      }
      l49() {
        return Companion_getInstance_0().d6i_1;
      }
      toString() {
        return 'DeletePairAssignmentsMutation(input=' + this.i6i_1.toString() + ')';
      }
      hashCode() {
        return this.i6i_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof DeletePairAssignmentsMutation()))
          return false;
        if (!this.i6i_1.equals(other.i6i_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'DeletePairAssignmentsMutation', VOID, VOID, [Mutation()]);
    DeletePairAssignmentsMutationClass = $;
  }
  return DeletePairAssignmentsMutationClass;
}
//region block: exports
export {
  Data as Data245eeyny59bq1,
  DeletePairAssignmentsMutation as DeletePairAssignmentsMutationfwlgebyv0y4l,
};
//endregion

//# sourceMappingURL=DeletePairAssignmentsMutation.mjs.map
